var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['forIntercom', { minimized: _vm.minimized }],attrs:{"id":"intercom-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }